// /home/oh33090489/real-estate-app/frontend/src/components/EstateEditor.jsx
import { useState } from "react";
import { sendEmailCode, verifyEmailCode, registerEmail } from "../api/authApi";

export default function EmailRegister({ onSuccess }) {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  return (
    <div className="login-section">
      <div style={{ fontWeight: 600, marginBottom: 8 }}>이메일 회원가입</div>

      {step === 1 && (
        <>
          <input
            placeholder="이메일"
            value={email}
            onChange={e=>setEmail(e.target.value)}
            style={{ width: "100%", marginBottom: 8 }}
            disabled={loading}
          />
          {error && <div style={{ color:"#dc2626", fontSize:13 }}>{error}</div>}
          <button style={{ width: "100%" }}
            disabled={loading}
            onClick={async () => {
              setLoading(true); setError("");
              try {
                await sendEmailCode(email);
                setStep(2);
              } catch {
                setError("이메일 발송 실패");
              } finally {
                setLoading(false);
              }
            }}
          >
            {loading ? "발송 중..." : "인증번호 발송"}
          </button>
        </>
      )}

      {step === 2 && (
        <>
          <input
            placeholder="인증번호"
            value={code}
            onChange={e=>setCode(e.target.value)}
            style={{ width: "100%", marginBottom: 8 }}
            disabled={loading}
          />
          {error && <div style={{ color:"#dc2626", fontSize:13 }}>{error}</div>}
          <button style={{ width: "100%" }}
            disabled={loading}
            onClick={async () => {
              setLoading(true); setError("");
              try {
                await verifyEmailCode(email, code);
                setStep(3);
              } catch {
                setError("인증번호가 올바르지 않습니다.");
              } finally {
                setLoading(false);
              }
            }}
          >
            {loading ? "확인 중..." : "인증 확인"}
          </button>
        </>
      )}

      {step === 3 && (
        <>
          <input placeholder="비밀번호" type="password"
            value={password} onChange={e=>setPassword(e.target.value)}
            style={{ width: "100%", marginBottom: 8 }} />
          <input placeholder="휴대폰번호"
            value={phone} onChange={e=>setPhone(e.target.value)}
            style={{ width: "100%", marginBottom: 8 }} />
          <input placeholder="이름(선택)"
            value={name} onChange={e=>setName(e.target.value)}
            style={{ width: "100%", marginBottom: 12 }} />
          {error && <div style={{ color:"#dc2626", fontSize:13 }}>{error}</div>}
          <button style={{ width: "100%" }}
            disabled={loading}
            onClick={async () => {
              setLoading(true); setError("");
              try {
                await registerEmail({ email, password, phone, name });
                onSuccess?.(); // 모달 닫기
              } catch {
                setError("회원가입 실패");
              } finally {
                setLoading(false);
              }
            }}
          >
            {loading ? "가입 중..." : "가입 완료"}
          </button>
        </>
      )}
    </div>
  );
}
